import { observable } from 'mobx'
import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'

class RenameDocumentStore {
  @observable isLoading = false

  rename = async (newName, objectId) => {
    this.isLoading = true
    try {
      await ResourcesRequest.rename(objectId, newName)
      ResourcesStore.search()
    } catch (e) {
      throw e
    } finally {
      this.isLoading = false
    }
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new RenameDocumentStore()
